import { Injectable, effect, inject, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslationService } from './translation.service';

export const APP_TITLE = 'Catalyst';

/**
 * Sets the browser tab title from the deepest route's `title` as "<Page> - Catalyst".
 *
 * Route titles are English translation keys; they are translated here and re-applied when
 * the language or the loaded translations change. Routes without a title show "Catalyst".
 */
@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly translationService = inject(TranslationService);
  private readonly pageKey = signal<string | undefined>(undefined);

  constructor() {
    super();
    effect(() => {
      // Reading the translations signal re-runs this when a language finishes loading.
      this.translationService.getTranslationsSignal()();
      const key = this.pageKey();
      const page = key ? this.translationService.translate(key) : '';
      this.title.setTitle(page ? `${page} - ${APP_TITLE}` : APP_TITLE);
    });
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.pageKey.set(this.buildTitle(snapshot));
  }
}
